<template>
  <!-- 热血盲盒管理-卡顿房间列表 -->
  <div class="test-box">
    <!-- header头部 -->
    <header>
      <el-form :inline="true" class="demo-form-inline">
        <el-form-item>
          <el-button size="small" type="primary" @click="getData"
            >刷新</el-button
          >
        </el-form-item>
      </el-form>
    </header>
    <!-- body内容 -->
    <div class="body-box">
      <el-table
        :data="dataList"
        v-loading="loading"
        style="margin-bottom: 20px"
      >
        <el-table-column prop="id" label="房间id" align="center">
        </el-table-column>
        <el-table-column prop="nums" label="房间地址" align="center">
          <template slot-scope="{ row }">
            <span v-if="row.nums == 2 || row.nums == 3"
              >https://m9skins.com/compete?room_id={{ row.id }}</span
            >
            <span v-if="row.nums == 4"
              >https://m9skins.com/competeFour?room_id={{ row.id }}</span
            >
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        background
        :page-size="dataMeta.per_page || 15"
        :total="dataMeta.total || 0"
        :current-page="dataMeta.current_page"
        @current-change="handlePageChange"
        v-if="dataMeta && dataMeta.total > dataMeta.per_page"
      ></el-pagination>
    </div>

    <!-- 弹窗 -->
  </div>
</template>

<script>
import {
  mapActions,
  mapMutations,
  mapState
} from 'vuex'
import http, {
  server,
  api,
  delApiData,
  getApiData,
  postApiData,
  patchApiData
} from '@/http'

export default {
  data() {
    return {
      loading: false, //加载动画
      query: {
        page: 1
      },
      dataList: undefined, //数据列表
      dataMeta: undefined, //底部跳转页面条
    }
  },
  created() {
    this.getData()
  },
  methods: {
    getData() {
      this.loading = true
      let params = this.query
      getApiData('battle_room_block', params).then(res => {
        if (res) {
          this.dataList = res.data
          this.dataMeta = res
        }
      }).finally(() => {
        this.loading = false
      })
    },
    handlePageChange(page) {
      //页面底部跳转页面
      this.query.page = page
      this.getData();
    },
  }

}

</script>
<style lang="less" scoped>
.debris_formula_config-box {
  header {
  }

  .body-box {
    // width: 800px;
  }
}
</style>
